/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { makeStyles } from "@mui/styles";
import Alert from '@mui/material/Alert';
import Dialog from '../../dialog/Dialog'
import ButtonStartIcon from '../../button/ButtonStartIcon'
import { handlerErrorV2 } from '../../../utils/errors'

const useStyles = makeStyles((theme) => ({
  xlarge: {
    textAlign: 'center',
    color: 'var(--muted)',
    width: theme.spacing(25),
    height: 'auto'
  },
  large: {
    textAlign: 'center',
    color: 'var(--muted)',
    width: theme.spacing(20),
    height: 'auto'
  },
  medium: {
    textAlign: 'center',
    color: 'var(--muted)',
    width: theme.spacing(10),
    height: 'auto'
  },
  dashboard: {
    textAlign: 'center',
    color: 'var(--muted)',
    width: theme.spacing(7),
    height: 'auto'
  },
  chart: {
    textAlign: 'center',
    color: 'var(--muted)',
    width: theme.spacing(6.5),
    height: 'auto'
  },
  small: {
    textAlign: 'center',
    color: 'var(--muted)',
    width: theme.spacing(5),
    height: 'auto'
  },
  xsmall: {
    textAlign: 'center',
    color: 'var(--muted)',
    width: theme.spacing(3),
    height: 'auto'
  },
  upload: {
    width: 'auto',
    textAlign: 'center',
    color: 'var(--muted)',
    height: '100%'
  }
}))

const DialogUploadImage = ({
  id,
  filename, value, onChange, 
  onUpload,
  alt = 'Upload',
  onClose, show
}) => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  const [src, setSrc] = useState(value)
  const [file, setFile] = useState({})
  const [error, setError] = useState('')
  const {getRootProps, getInputProps, open, acceptedFiles} = useDropzone({
    // Disable click and keydown behavior
    noClick: true,
    noKeyboard: true,
    maxFiles: 1,
    multiple: false,
  });

  useEffect(() => {
    setSrc(value)
  }, [value])
  
  useEffect(() => {
    if (acceptedFiles[0]) {
      setError('')
      const name = acceptedFiles[0].name.split('.')
      const currentFile = acceptedFiles[0]
      
      if (currentFile.size > 26214400) {
        setError('Max file size 25Mb.')
        return
      }
      if (name[1] !== 'png') {
        setError('Format invalid. Required Image png')
        return
      }

      onChange({
        file: currentFile, 
        filename,
        size: currentFile.size,
        lastModified: currentFile.lastModified,
        extension: name[1],
        mimetype: currentFile.type,
        description:  name[0],
        detail: currentFile.name,
        link: URL.createObjectURL(currentFile)
      })

      setSrc(URL.createObjectURL(currentFile))
    }
    if (acceptedFiles) {
      const files = acceptedFiles?.map(file => ({
        name: filename || file?.name,
        size: file.size,
        lastModified: file.lastModified,
        type: file.type || 'image/png',
        file,
    }))
      setFile(files)
    }
  }, [acceptedFiles])

  const onClick = async () => {
    if (!file) {
      setError('Please select a file')
      return
    }
    setLoading(true);
    try {
      const result = await onUpload(file)
      if (result.error) {
        setError(result.error || 'Something went wrong. Please try again.')
      } else {
        onClose()
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      setError(message)
    } finally {
      setLoading(false)
    }
  }

  const Actions = (
    <>
      <ButtonStartIcon
        onClick={onClose}
        color='primary'
        variant='outlined'
        disabled={loading}
        startIcon={["fal","times"]}
      >
        Cancel
      </ButtonStartIcon>
      <ButtonStartIcon
        onClick={onClick}
        color='primary'
        variant='contained'
        disabled={loading}
        loading={loading}
        startIcon={["fas","upload"]}
      >
        Upload
      </ButtonStartIcon>
    </>
  );

	return (
    <Dialog
      id={`${id}-upload-image`}
      show={show} 
      title='upload image'
      onClose={onClose}
      actions={Actions}
    >
      <div {...getRootProps({ multiple: false, className: 'dropzone'})}  onClick={open} className='text-center relative border border-dashed cursor-pointer bg-clickeabled h-44 pt-2 pb-10'>
        <input multiple={false} {...getInputProps({ multiple: false })} />
        <img className={classes.upload}  src={src} alt={alt} />
        <div className='absolute bottom-0 left-0 right-0'>
        <p className='text-muted-foreground opacity-75 py-2 px-2 bg-muted  text-center text-sm '>Drag 'n' drop some file here, or click to select file</p>
        </div>

      </div>
      { error && 
        <Alert 
          severity="error"
          className='mt-4'
          onClose={() => setError(null)}
        >
          {error}
        </Alert> 
      }
    </Dialog>
	)
}

const UploadImage = ({ 
  permission, 
  filename, value, 
  onChange, onUpload,
  alt = 'Upload', size = 'large', 
}) => {
  const classes = useStyles()
  const [show, setShow] = useState(false)

  return (
    <>
      <div className={`flex items-center justify-center relative ${permission ? 'border border-dashed cursor-pointer bg-clickeabled' : ''}`} onClick={permission ? () => setShow(true) : undefined}>
        <img className={classes[size]}  src={value} alt={alt} />
      </div>
      { show &&
        <DialogUploadImage 
          permission={permission} 
          filename={filename} 
          value={value}
          onUpload={onUpload}
          onChange={onChange} 
          alt={alt} 
          onClose={() => setShow(false)} 
          show={show}
        />
      }
    </>

  )
}
export default UploadImage
